// extracted by mini-css-extract-plugin
export default {"dashboardAssignmentsPage":"Assignments_dashboardAssignmentsPage__FkT1m","row":"Assignments_row__8YKxC","column":"Assignments_column__8qX3u"};